export default "__VITE_ASSET__BD_3RAZM__"